import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export type ResultBadgeKind = 'passed' | 'failed' | 'in-progress' | 'open';

@Component({
  selector: 'app-result-status-badge',
  imports: [TranslatePipe],
  templateUrl: './result-status-badge.component.html',
  styleUrl: './result-status-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultStatusBadgeComponent {
  readonly kind = input.required<ResultBadgeKind>();

  readonly labelKey = computed(() => {
    switch (this.kind()) {
      case 'passed':
        return 'testPlans.report.status.passed';
      case 'failed':
        return 'testPlans.report.status.failed';
      case 'in-progress':
        return 'testPlans.report.status.inProgress';
      case 'open':
        return 'testPlans.report.status.open';
    }
  });
}
